<template>
    <div v-if="config.buttons.length > 0" class="overview__actions" :class="{'overview__actions--sticky': sticky}">
        <frm-overview-actions-button-group v-for="(actions, groupIndex) in groups"
                                           :key="groupIndex"
                                           :handle-action="handleAction"
                                           :disabled="disabled"
                                           :actions="actions"
                                           :config="config"
        />
        <slot />
    </div>
</template>

<script>
import DefaultOverviewMixin from '../../mixins/Overview/Default';
import OverviewActionsButtonGroup from './ActionsButtonGroup.vue';

export default {
    mixins: [DefaultOverviewMixin],

    components: {
        'frm-overview-actions-button-group': OverviewActionsButtonGroup,
    },

    props: {
        config: {
            type: Object,
            required: true,
        },

        disabled: {
            type: Boolean,
            default: false,
        },

        handleAction: {
            type: Function,
            required: true,
        },

        sticky: {
            type: Boolean,
            default: false,
        },
    },

    computed: {
        groups() {
            // Split the actions into groups based on the 'break' type
            const groups = [];

            let currentGroup = [];
            this.config.buttons.forEach((action) => {
                if (action.type === 'break') {
                    if (currentGroup.length > 0) {
                        groups.push(currentGroup);
                        currentGroup = [];
                    }
                } else {
                    currentGroup.push(action);
                }
            });

            if (currentGroup.length > 0) {
                groups.push(currentGroup);
            }

            return groups;
        },
    },
};
</script>
